import {decrypt, encrypt} from '@shared/utils/LocalStorage';

class Storage {
  static KEYS = {
    APP_VERSION: 'app-version',
    PORTAL: 'PORTAL',
    AUTH_TOKEN: 'AUTH_TOKEN',
    CLIENT_ID: 'CLIENT_ID',
    ADMIN_AUTH_TOKEN: 'ADMIN_AUTH_TOKEN',
    ADMIN_ID: 'ADMIN_ID',
    ADVISOR_AUTH_TOKEN: 'ADVISOR_AUTH_TOKEN',
    ADVISOR_ID: 'ADVISOR_ID',
    NEW_CLIENT: 'NEW_CLIENT',
    CLICKED_COMPANY_NAME: 'CLICKED_COMPANY_NAME',
    CLIENT_ACCOUNT_INFO: 'CLIENT_ACCOUNT_INFO',
    COMPANY_ON_BOARD_INFO: 'COMPANY_ON_BOARD_INFO'
  };

  static setItem = (key: string, value: any): void => {
    if (!value) {
      value = '';
    }
    if (typeof value !== 'string') {
      value = JSON.stringify(value);
    }
    let storageKey = Storage.searchKey(key);
    if (!storageKey) {
      storageKey = encrypt(key);
    }
    localStorage.setItem(storageKey, encrypt(value));
  };

  static getItem = (key: string, shouldParse?: boolean): string | null => {
    const keyVal = decrypt(localStorage.getItem(Storage.searchKey(key)));
    if (shouldParse && keyVal) {
      return JSON.parse(keyVal);
    }
    return keyVal;
  };

  static searchKey(key: string): string {
    const keys = Object.keys(localStorage);
    let i = keys.length;
    while (i--) {
      try {
        if (decrypt(keys[i]) === key) {
          return keys[i];
        }
      } catch (e) {
        localStorage.removeItem(keys[i]);
      }
    }
    return '';
  }

  static removeItem = (key: string): void => {
    localStorage.removeItem(Storage.searchKey(key));
  };

  static clear = (): void => {
    localStorage.clear();
  };
}

export default Storage;
